/**
 * Communicator 2.0 als Single-Page-App unter `/chat` (#504).
 *
 * Dieselbe Implementierung wie im Desktop-Fenster, nur ohne Shell: kein
 * Fenstermanager, keine Taskbar, kein Cortex. Navigation und `AppHost` kommen
 * vom `StandaloneLayout`; diese Seite mountet nur die App.
 *
 * Lazy wie im `WindowContainer`, damit der Desktop-Pfad keinen zusätzlichen
 * Chunk im Erst-Bundle bekommt.
 */
import { Suspense, lazy } from 'react'
import { Loader2 } from 'lucide-react'

const Communicator2App = lazy(
  () => import('@/components/applications/communicator2/Communicator2App'),
)

export function StandaloneChatPage() {
  return (
    <div className="app-surface h-full overflow-hidden">
      <Suspense
        fallback={
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="h-6 w-6 animate-spin motion-reduce:animate-none text-[var(--text-secondary)]" />
          </div>
        }
      >
        <Communicator2App />
      </Suspense>
    </div>
  )
}
